'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["label"],
  _excluded2 = ["label"],
  _excluded3 = ["contextual", "use", "minHeight", "label", "title"];
import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import UILoadingDots from './UILoadingDots';
import UILoadingSpinner from './UILoadingSpinner';
import UIOverlay from '../overlay/UIOverlay';
import memoizeOne from 'react-utils/memoizeOne';
import { toPx } from '../utils/Styles';
import { notRequired, hidden } from '../utils/propTypes/decorators';
import { wrapPropTypes } from '../utils/propTypes/wrapPropTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const OverlayInnerWrapper = styled(UIOverlay.defaultProps.Inner).withConfig({
  displayName: "UILoadingOverlay__OverlayInnerWrapper",
  componentId: "xkdwun-0"
})(["display:flex;justify-content:center;align-items:center;height:100%;"]);
const DEFAULT_USE = 'spinner';
const USE_VARIANTS = {
  dots: {
    Component(_ref) {
      let {
          label
        } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, _excluded);
      return /*#__PURE__*/_jsx(UILoadingDots, Object.assign({}, rest, {
        title: label
      }));
    }
  },
  spinner: {
    Component(_ref2) {
      let {
          label
        } = _ref2,
        rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
      return /*#__PURE__*/_jsx(UILoadingSpinner, Object.assign({}, rest, {
        label: label
      }));
    }
  }
};
function getOverlayStyles(minHeight) {
  if (minHeight == null) return undefined;
  return {
    minHeight: toPx(minHeight)
  };
}
export default class UILoadingOverlay extends Component {
  constructor(props) {
    super(props);
    this._getOverlayStyles = memoizeOne(getOverlayStyles);
  }
  render() {
    const _this$props = this.props,
      {
        contextual,
        use,
        minHeight,
        label,
        title
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded3);
    const Loader = (USE_VARIANTS[use] || USE_VARIANTS[DEFAULT_USE]).Component;
    return /*#__PURE__*/_jsx(UIOverlay, {
      centerContent: false,
      contextual: contextual,
      Inner: OverlayInnerWrapper,
      use: "light",
      width: 100,
      style: this._getOverlayStyles(minHeight),
      children: /*#__PURE__*/_jsx(Loader, Object.assign({}, rest, {
        label: label || title
      }))
    });
  }
}
UILoadingOverlay.displayName = 'UILoadingOverlay';
UILoadingOverlay.propTypes = Object.assign({}, wrapPropTypes({
  propTypes: UILoadingSpinner.propTypes,
  defaultProps: UILoadingSpinner.defaultProps
}), wrapPropTypes({
  propTypes: UILoadingDots.propTypes,
  defaultProps: UILoadingDots.defaultProps
}), {
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: hidden(notRequired(UILoadingDots.propTypes.title)),
  contextual: UIOverlay.propTypes.contextual,
  use: PropTypes.oneOf(Object.keys(USE_VARIANTS)),
  label: notRequired(UILoadingSpinner.propTypes.label)
});
UILoadingOverlay.defaultProps = {
  use: DEFAULT_USE,
  contextual: false,
  showLabel: false
};